import { render } from "./read-career.vue?vue&type=template&id=2bc068d5&scoped=true"
import script from "./read-career.vue?vue&type=script&lang=js"
export * from "./read-career.vue?vue&type=script&lang=js"

import "./read-career.vue?vue&type=style&index=0&id=2bc068d5&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc068d5"]])

export default __exports__